/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-04-07 15:05:46
 * @LastEditors: linxi
 * @LastEditTime: 2021-08-24 09:58:06
 */
import { method } from "lodash";
import { api } from "../app/applicationSlice";
import { BillingCategory } from "../models/billingCategory";
import { API_PREFIX } from "./constant";
import { Request } from "./request";

export interface examinePageParams {
  current?: number;
  size?: number;
  name?: string;
  state: number;
  billingCategory?: string;
}

export interface examineSubmitbody {
  billingCategory: BillingCategory;
  mnemonicCode: string;
  name: string;
  retailPrice: number;
  accountUnit: string;
  no: number;
  insuranceCode: number;
  id?: number;
}

export interface logoutOrEnableParams {
  ids: string;
  state: number;
}

export function examinePage(params: examinePageParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/treatmentServiceCatalog/page`,
    method: "GET",
    params,
  };
}

export function examineSubmit(body: examineSubmitbody): Request {
  return {
    url: `${API_PREFIX}/blade-store/treatmentServiceCatalog/submit`,
    method: "POST",
    body,
  };
}

export function examinDetail(id: number): Request {
  return {
    url: `${API_PREFIX}/blade-store/treatmentServiceCatalog/detail`,
    method: "GET",
    params: {
      id,
    },
  };
}

export function examinelogoutorEnable(id: number): Request {
  return {
    url: `${API_PREFIX}/blade-store/treatmentServiceCatalog/logoutOrEnable`,
    method: "POST",
    params: {
      id,
    },
  };
}

export function examineLogoutEnableList(body: logoutOrEnableParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/treatmentServiceCatalog/logoutbatch`,
    method: "POST",
    body,
  };
}
